import { createI18n } from 'vue-i18n'

// 中文语言包
const zhCN = {
  common: {
    search: '搜索',
    searchPlaceholder: '请输入商品名称、编码或规格',
    noSearchResults: '暂无搜索结果，请尝试其他关键词',
    searchFailed: '搜索失败，请稍后重试',
    cancel: '取消',
    confirm: '确定',
    login: '登录',
    logout: '退出登录',
    register: '注册',
    home: '首页',
    cart: '购物车',
    order: '我的订单',
    profile: '个人中心',
    account: '账户管理',
    user: '用户',
    notLoggedIn: '未登录',
    loginPrompt: '请登录或注册',
    mainFeatures: '主要功能',
    settings: '设置',
    language: '语言',
    logoutConfirm: '确定要退出登录吗？',
    logoutSuccess: '已退出登录',
    logoutFailed: '退出登录失败',
    delete: '删除',
    productCode: '商品编码',
    hotSearch: '热门搜索',
    loading: '加载中...',
    noMore: '没有更多了',
    loadingMore: '正在加载更多...',
    backToTop: '回到顶部',
    copy: '复制',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
  },
  home: {
    title: '首页',
    productCategory: '商品分类',
    allProducts: '全部商品',
    reset: '重置',
    searchResults: '搜索结果',
    sortBy: '排序方式',
    sortDefault: '默认排序',
    priceLowToHigh: '价格从低到高',
    priceHighToLow: '价格从高到低',
    nameAsc: '名称排序',
    totalFound: '共{count}个商品',
    noSearchResult: '暂无搜索结果，请尝试其他关键词',
    noProducts: '暂无商品数据',
    viewAllProducts: '查看所有商品',
    noSpec: '暂无规格',
    noCode: '暂无编码',
    unit: '单位',
    piece: '个',
    uncategorized: '未分类',
    currency: '¥',
    addToCartSuccess: '已添加到购物车',
    addToCartError: '添加失败，请稍后重试',
    noMoreProducts: '没有更多商品了',
    loadingMoreProducts: '正在加载更多商品...',
    expand: '展开',
    collapse: '收起',
    expandMore: '展开更多({count})',
    mobileHome: '首页',
    mobileCategory: '分类',
    mobileCart: '购物车',
    mobileOrder: '订单',
    category: '分类',
  },
  productDetail: {
    title: '商品详情',
    productCode: '商品编码：',
    price: '价格',
    specs: '规格参数',
    unit: '单位：',
    quantity: '购买数量',
    addToCart: '加入购物车',
    buyNow: '立即购买',
    productNote: '商品备注',
    notFound: '商品不存在或已下架',
    notFoundDesc: '抱歉，您访问的商品可能已被移除或暂时不可用',
    backToHome: '返回首页',
    copyCode: '复制编码',
    copyCodeSuccess: '商品编码已复制',
    addCartSuccess: '{name} 已加入购物车',
    addCartError: '添加失败，请稍后重试',
    quantityMin: '购买数量不能小于1',
    loginRequired: '请先登录',
    fetchError: '获取商品详情失败，请稍后重试',
    imageStatus: '{current}/{total}',
    new: '新品',
    hot: '热销',
  },
  profile: {
    title: '个人中心',
    admin: '管理员',
    user: '普通用户',
    account: '账户管理',
    basicInfo: '基本信息',
    basicInfoDesc: '查看和管理您的账户基本信息',
    security: '账户安全',
    securityDesc: '管理您的账户安全设置',
    userId: '用户ID',
    userAccount: '用户账号',
    userName: '用户姓名',
    tenantId: '租户ID',
    phone: '手机号',
    email: '邮箱',
    notSet: '未设置',
    set: '已设置',
    bind: '绑定',
    change: '修改',
    loginPassword: '重置密码',
    phoneBinding: '手机绑定',
    changePassword: '修改密码',
    resetPassword: '重置密码',
    phonePlaceholder: '请输入手机号',
    phoneRequired: '请输入手机号',
    phoneInvalid: '请输入正确的手机号',
    verificationCode: '验证码',
    codePlaceholder: '请输入验证码',
    codeRequired: '请输入验证码',
    codeInvalid: '验证码为6位数字',
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入4-20位新密码',
    newPasswordRequired: '请输入新密码',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入新密码',
    confirmPasswordRequired: '请确认新密码',
    passwordLength: '密码长度为4-20位',
    passwordMismatch: '两次输入的密码不一致',
    getCode: '获取验证码',
    resendAfter: '{seconds}秒后重发',
    confirmReset: '确认修改',
    cancelResetConfirm: '确定要取消重置密码吗？',
    processing: '正在处理中，请稍候',
    resetSuccess: '密码重置成功',
    resetFailed: '重置密码失败，请稍后重试',
    languageDesc: '选择您偏好的界面语言',
    passwordDesc: '定期修改密码可提高账户安全性',
    phoneDesc: '绑定手机可用于密码重置和账户安全验证',
    bindPhoneInfo: '手机绑定功能开发中...',
    bindEmailInfo: '邮箱绑定功能开发中...',
    codeSent: '验证码已发送',
    // 新增地址管理相关翻译
    address: '我的地址',
    addressDesc: '查看您的收货地址',
    defaultAddress: '默认地址',
    usedCount: '已使用{count}次',
    lastUsed: '最后使用',
    createdAt: '创建时间',
    createdBy: '创建人',
    noAddress: '暂无收货地址',
    fetchAddressFailed: '获取地址列表失败',
    resetPasswordHint: '重置密码后，密码将设置为默认密码0000，请妥善保管并及时修改',
    reloginHint: '密码已重置，请使用新密码0000重新登录',
    modifyPassword: '修改密码',
    modifyPasswordHint: '修改密码成功后，您需要重新登录系统。',
    oldPassword: '旧密码',
    oldPasswordPlaceholder: '请输入当前密码',
    newPasswordPlaceholder: '请输入新密码（至少4位）',
    confirmPasswordPlaceholder: '请再次输入新密码',
    oldPasswordRequired: '请输入旧密码',
    passwordSame: '新密码不能与旧密码相同',
    passwordMismatch: '两次输入的密码不一致',
    confirmModify: '确认修改',
    cancelModifyConfirm: '确定要取消修改密码吗？',
    passwordModifySuccess: '密码修改成功！请使用新密码重新登录',
    passwordModifyFailed: '密码修改失败',
    fetchCaptchaFailed: '获取验证码失败，请稍后重试',
    captchaRefresh: '点击刷新',
    contactAdminReset: '请联系管理员重置密码',
    addAddress: '添加地址',
    editAddress: '编辑地址',
    saveChanges: '保存修改',
    setDefault: '设置默认',
    defaultAddress: '默认地址',
    noAddress: '暂无地址',
    addAddressBtn: '添加地址',
    contactRequired: '请输入联系人',
    phoneRequired: '请输入手机号',
    phoneInvalid: '手机号格式错误',
    areaRequired: '请选择省市区',
    areaIncomplete: '省市区信息不完整，请重新选择',
    addressRequired: '请输入详细地址',
    setDefaultAddress: '设为默认地址',
    saveAddressSuccess: '添加地址成功',
    updateAddressSuccess: '更新地址成功',
    setDefaultAddressSuccess: '设置默认地址成功',
    saveAddressFailed: '添加地址失败',
    updateAddressFailed: '更新地址失败',
    setDefaultAddressFailed: '设置默认地址失败',
    fetchAddressFailed: '获取地址列表失败',
  },
  header: {
    welcome: '欢迎来到订货商城',
    subtitle: 'Wholesale Mall',
    loginRegister: '登录/注册',
    myAccount: '我的账户',
    myOrders: '我的订单',
    myCart: '我的购物车'
  },
  login: {
    welcomeTitle: '欢迎使用订货系统',
    welcomeDescription: '高效便捷的订货管理平台，助力企业数字化采购管理，提升订货效率，降低运营成本。',
    feature1: '商品管理',
    feature2: '订单处理',
    feature3: '库存查询',
    feature4: '数据统计',
    welcomeBack: '欢迎回来，请登录您的账户',
    username: '账号',
    usernamePlaceholder: '请输入账号',
    usernameRequired: '请输入账号',
    usernameLength: '账号长度为3-50个字符',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    passwordRequired: '请输入密码',
    passwordLength: '密码长度为4-20个字符',
    captcha: '验证码',
    captchaPlaceholder: '请输入验证码',
    captchaRequired: '请输入验证码',
    captchaLength: '验证码为4位字符',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    forgotPasswordHint: '请联系管理员重置密码',
    noAccount: '还没有账户？',
    registerNow: '立即注册',
    loginSuccess: '登录成功！',
    loginFailed: '登录失败',
    loggingIn: '登录中...',
    testAccount: '测试账号',
    defaultUsername: '管理员',
    companyName: '订货商城',
    networkError: '网络连接失败，请检查网络设置',
    timeoutError: '请求超时，请稍后重试',
    credentialsError: '账号或密码错误',
    // 新增
    paramsError: '请求参数错误',
    credentialsError: '账号或密码错误',
    disabledError: '账号已被禁用或没有权限',
    endpointError: '登录接口不存在',
    serverError: '服务器内部错误，请联系管理员',
    loginError: '登录失败',
    loginRequestFailed: '登录请求失败',
    networkError: '网络连接失败，请检查网络设置',
    logoutFailed: '退出失败',
    logoutError: '退出登录失败',
    tokenExpired: 'Token已过期，已清除本地登录状态',
    fetchUserFailed: '获取用户信息失败',
    fetchUserError: '刷新用户信息失败',
    userInfoUpdated: '用户信息已更新',
  },
  register: {
    welcomeTitle: "欢迎注册",
    welcomeDescription: "加入我们，开启全新的管理体验",
    feature1: "高效管理系统",
    feature2: "多端数据同步",
    feature3: "实时数据监控",
    feature4: "专业客服支持",
    title: "注册账号",
    subtitle: "创建您的新账户",
    title: '注册新账户',
    subtitle: '创建您的批发商城账户',
    mobile: '手机号',
    mobilePlaceholder: '请输入手机号',
    realName: '真实姓名',
    realNamePlaceholder: '请输入真实姓名',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    verifyCode: '验证码',
    verifyCodePlaceholder: '请输入短信验证码',
    sendCode: '获取验证码',
    resendCode: '重新发送 ({countdown}s)',
    agreement: '我已阅读并同意《用户协议》',
    registerButton: '注册',
    hasAccount: '已有账户？',
    loginNow: '立即登录',
    processing: '注册中...',
    success: '注册成功！请登录',
    failure: '注册失败，请稍后重试',
    codeSent: '验证码已发送',
    sendCodeFailed: '发送验证码失败',
    validation: {
      mobileRequired: '请输入手机号',
      mobileInvalid: '手机号格式不正确',
      realNameRequired: '请输入真实姓名',
      realNameLength: '姓名长度为 2-50 个字符',
      passwordRequired: '请输入密码',
      passwordLength: '密码长度为 4-20 个字符',
      confirmPasswordRequired: '请确认密码',
      passwordMismatch: '两次输入的密码不一致',
      verifyCodeRequired: '请输入验证码',
      verifyCodeInvalid: '验证码为 4 位数字',
      agreementRequired: '请同意用户协议',
      sendTooFrequent: '发送过于频繁，请稍后再试',
      dailyLimitReached: '今日发送次数已达上限，请明天再试'
    }
  },

  checkout: {
    title: '订单结算',
    back: '返回上一页',
    shippingInfo: '收货信息',
    addAddress: '新增地址',
    edit: '编辑',
    setDefault: '设置默认',
    default: '默认',
    chooseOther: '选择其他地址',
    collapseAddress: '收起地址',
    noAddress: '暂无收货地址',
    addAddressBtn: '添加地址',
    loadingAddress: '正在加载地址...',
    productInfo: '商品信息',
    totalItems: '共 {count} 件商品',
    unit: '单位：',
    orderSummary: '订单汇总',
    totalPrice: '商品总价',
    shippingFee: '运费',
    freeShipping: '¥0.00',
    totalPayable: '应付总额',
    orderRemark: '订单备注',
    remarkPlaceholder: '请填写订单备注（选填，最多200字）',
    paymentMethod: '支付方式',
    noPayment: '无需支付，直接下单',
    noPaymentDesc: '适用内部结算',
    onlinePayment: '在线支付',
    onlinePaymentDesc: '支持微信、支付宝、银行卡支付',
    wechat: '微信支付',
    alipay: '支付宝',
    bankCard: '银行卡支付',
    submitOrder: '提交订单 ({count}件)',
    goPay: '去支付',
    submitTipNoPayment: '点击提交订单，将直接创建订单',
    submitTipPayment: '点击去支付，将跳转到支付页面完成支付',
    selectAddressRequired: '请选择收货地址',
    contactInfoIncomplete: '收货信息不完整，请完善联系人和手机号信息',
    cartEmpty: '请选择要购买的商品',
    confirmPayment: '确认支付',
    confirmPaymentDetail: '订单总额 ¥{amount}，确认进行在线支付吗？',
    confirmOrder: '确认订单',
    confirmOrderDetail: '订单总额 ¥{amount}，确认提交订单吗？',
    payNow: '去支付',
    submitNow: '提交订单',
    cancel: '取消',
    paymentSuccess: '支付并下单成功！',
    orderSuccess: '订单提交成功！',
    paymentFailed: '支付或下单失败',
    orderFailed: '订单提交失败',
    addressFormTitle: '新增地址',
    editAddressTitle: '编辑地址',
    contact: '联系人',
    contactPlaceholder: '请输入联系人姓名',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    area: '省市区',
    areaPlaceholder: '请选择省市区',
    detailAddress: '详细地址',
    detailAddressPlaceholder: '请输入详细地址',
    setDefaultSwitch: '设为默认',
    save: '保存',
    cancel: '取消',
    saveSuccess: '地址保存成功',
    saveFailed: '保存地址失败，请稍后重试',
    fetchAddressFailed: '获取地址列表失败，请稍后重试',
    setDefaultSuccess: '设置默认地址成功',
    setDefaultFailed: '设置默认地址失败，请稍后重试',
    areaRequired: '请选择完整的省市区',
    areaIncomplete: '省市区信息不完整，请重新选择',
    invalidPhone: '手机号格式不正确',
    scanToPay: '扫码支付',
    useWechatOrAlipayScan: '请使用微信或支付宝扫码支付',
    payLater: '稍后支付',
    paymentCompleted: '已完成支付',
    qrGenerated: '支付二维码已生成',
    submitOrderFailed: '提交订单失败',
    confirmPaySuccess: '确认已支付成功？',
    paymentConfirm: '支付确认',
    yes: '是',
    no: '否',
    qrExpireTip: '付款码15分钟内会失效，剩余时间：',
    qrExpired: '付款码已失效，请返回重新点击支付',
    qrExpiredMessage: '付款码已失效，请重新点击支付',
    retryPay: '重新支付',
    orderNotFound: '未找到订单',
    getPayUrlFailed: '获取支付链接失败',
    paymentSuccess: '支付成功',
    paymentFailed: '支付失败',
    success: '成功',
    error: '错误',
    ok: '确定',
    orderWillRedirect: '订单即将跳转',
    redirectingIn: '正在跳转',
    orderDetailWillRefresh: '订单详情即将刷新',
    refreshingIn: '正在刷新'
  },
  cart: {
    title: '购物车',
    back: '返回上一页',
    selectAll: '全选',
    selectedCount: '（已选 {count} 件）',
    deleteSelected: '删除选中的商品',
    clearCart: '清空购物车',
    code: '编码：{code}',
    unit: '单位：{unit}',
    delete: '删除',
    emptyTitle: '购物车还是空的',
    emptyDesc: '赶紧去挑选心宜的商品吧',
    goHome: '去首页逛逛',
    selectedProducts: '已选商品',
    total: '合计：',
    checkout: '去结算',
    checkoutCount: '({count})',
    confirmDeleteSelected: '确定要删除选中的 {count} 件商品吗？',
    confirmDelete: '确定要删除该商品吗？',
    confirmClear: '确定要清空购物车吗？',
    confirm: '确定',
    cancel: '取消',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败，请稍后重试',
    clearSuccess: '购物车已清空',
    clearFailed: '清空失败，请稍后重试',
    updateFailed: '更新数量失败，请稍后重试',
    selectWarning: '请选择要结算的商品',
    checkoutFailed: '结算失败，请稍后重试',
    quantityMin: '数量不能小于1',
    updateSelectFailed: '更新选中状态失败，请稍后重试',
    operationFailed: '操作失败，请稍后重试',
    // 新增
    loginRequired: '请先登录',
    addFailed: '加入购物车失败',
    updateFailed: '更新数量失败',
    deleteFailed: '删除商品失败',
    batchDeleteFailed: '批量删除失败',
    clearFailed: '清空购物车失败',
    updateSelectionFailed: '更新选中状态失败',
    itemNotFound: '购物车项不存在',
    cartItemNotFound: '购物车项不存在: {id}',
  },

  // ====== 订单管理 ======
  orderManage: {
    title: '订单管理',
    back: '返回上一页',
    totalOrders: '订单总数',
    pendingConfirm: '待确认',
    shipped: '已发货',
    completed: '已完成',
    cancelled: '已取消',
    orderNo: '订单号',
    orderStatus: '订单状态',
    allStatus: '全部状态',
    searchOrder: '搜索订单',
    reset: '重置',
    refresh: '刷新',
    orderNoLabel: '订单号',
    createTime: '下单时间',
    orderAmount: '订单金额',
    productQuantity: '商品数量',
    status: '订单状态',
    paymentStatus: '支付状态',
    shipmentTime: '发货时间',
    voucherDate: '凭证日期',
    shippingInfo: '收货信息',
    operation: '操作',
    detail: '详情',
    statusPending: '待支付',
    statusConfirmed: '已支付',
    statusShipping: '已发货',
    statusCompleted: '已完成',
    statusCancelled: '已取消',
    paymentUnpaid: '未支付',
    paymentPaid: '已支付',
    paymentCancelled: '支付取消',
    paymentRefunded: '已退款',
    paymentFailed: '支付失败',
    paymentProcessing: '处理中',
    noOrders: '暂无订单数据',
    noOrdersDesc: '当前筛选条件下没有找到订单记录',
    viewAllOrders: '查看全部订单',
    totalCount: '共 {count} 条订单',
    unitPiece: '件',
    notShipped: '未发货',
    copySuccess: '已复制到剪贴板',
  },
  // ====== 订单详情 ======
  orderDetail: {
    title: '订单详情',
    back: '返回上一页',
    currentStatus: '当前状态：',
    orderCancelled: '订单已取消',
    cancelReason: '取消原因：',
    cancelTime: '取消时间：',
    stepPending: '待确认',
    stepPendingDesc: '等待商家确认订单',
    stepConfirmed: '已确认',
    stepConfirmedDesc: '商家已确认订单',
    stepShipped: '已发货',
    stepShippedDesc: '商品已发出',
    stepCompleted: '已完成',
    stepCompletedDesc: '订单已完成',
    shippedTip: '商品已发货，请及时确认收货',
    cancelTip: '订单尚未确认，您可以取消订单',
    cancelOrder: '取消订单',
    confirmReceipt: '确认收货',
    viewLogistics: '查看物流',
    confirmReceiptConfirm: '请确认您已收到商品？确认后订单将变为已完成状态',
    cancelOrderTitle: '取消订单',
    cancelOrderReasonPlaceholder: '请填写取消订单的原因（可选）',
    confirmCancel: '确定取消',
    cancelOrderWarning: '确定要取消此订单吗？取消后订单将无法恢复',
    cancelOrderConfirmTitle: '确认取消订单',
    cancelOrderSuccess: '订单取消成功',
    orderInfo: '订单信息',
    orderNoLabel: '订单号：',
    createTime: '下单时间：',
    status: '订单状态：',
    totalQuantity: '商品总数：',
    totalAmount: '订单总额：',
    paymentStatusLabel: '支付状态：',
    paymentTime: '支付时间：',
    shipmentTime: '发货时间：',
    confirmTime: '确认时间：',
    voucherDate: '凭证日期：',
    deliveryDate: '配送日期：',
    shippingInfo: '收货信息',
    recipient: '收货人：',
    phone: '联系电话：',
    address: '收货地址：',
    remark: '订单备注',
    logisticsInfo: '物流信息',
    logisticsCompany: '物流公司：',
    trackingNumber: '物流单号：',
    logisticsNetwork: '物流网点：',
    trackingUrl: '查询链接：',
    clickToTrack: '点击查询物流',
    productInfo: '商品信息',
    productName: '商品名称',
    unit: '单位',
    quantity: '数量',
    unitPrice: '单价',
    taxRate: '税率',
    subtotal: '小计',
    totalItems: '共 {count} 件商品',
    totalQuantity: '总计{quantity}件数',
    pointsAmount: '积分金额：',
    discountAmount: '优惠金额：',
    orderTotal: '订单总额：',
    productCode: '编码：',
    productSpec: '规格：',
    productBarcode: '条码：',
    orderNotFound: '订单不存在或已被删除',
    backToOrderList: '返回订单列表',
    copyOrderNo: '订单号已复制到剪贴板',
    copyTrackingNo: '物流单号已复制到剪贴板',
    noLogistics: '暂无物流信息',
    payNow: "去支付",
    paySuccess: "支付成功",
    payFailed: "支付失败",
    orderIdMissing: "订单编号缺失",
    "payNow": "去支付",
    "paySuccess": "支付成功",
    "payFailed": "支付失败",
    "scanToPay": "扫码支付",
    "useWechatOrAlipayScan": "请使用微信或支付宝扫描二维码完成支付",
    "payLater": "稍后支付",
    "paymentCompleted": "已完成支付",
    "confirmPaySuccess": "确认已成功支付？",
    "paymentConfirm": "支付确认",
    "yes": "是",
    "no": "否"
  },

}

// 英文语言包
const enUS = {
  common: {
    search: 'Search',
    searchPlaceholder: 'Enter product name, code or specifications',
    noSearchResults: 'No search results, please try other keywords',
    searchFailed: 'Search failed, please try again later',
    cancel: 'Cancel',
    confirm: 'Confirm',
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    home: 'Home',
    cart: 'Cart',
    order: 'My Orders',
    profile: 'Profile',
    account: 'Account Management',
    user: 'User',
    notLoggedIn: 'Not Logged In',
    loginPrompt: 'Please login or register',
    mainFeatures: 'Main Features',
    settings: 'Settings',
    language: 'Language',
    logoutConfirm: 'Are you sure you want to logout?',
    logoutSuccess: 'Logged out successfully',
    logoutFailed: 'Logout failed',
    delete: 'Delete',
    productCode: 'Product Code',
    hotSearch: 'Hot Search',
    loading: 'Loading...',
    noMore: 'No more',
    loadingMore: 'Loading more...',
    backToTop: 'Back to Top',
    copy: 'Copy',
    copySuccess: 'Copied successfully',
    copyFailed: 'Copy failed',
  },
  home: {
    title: 'Home',
    productCategory: 'Product Categories',
    allProducts: 'All Products',
    reset: 'Reset',
    searchResults: 'Search Results',
    sortBy: 'Sort By',
    sortDefault: 'Default',
    priceLowToHigh: 'Price: Low to High',
    priceHighToLow: 'Price: High to Low',
    nameAsc: 'Name: A to Z',
    totalFound: '{count} products found',
    noSearchResult: 'No search results, please try other keywords',
    noProducts: 'No product data',
    viewAllProducts: 'View All Products',
    noSpec: 'No specification',
    noCode: 'No code',
    unit: 'Unit',
    piece: 'piece',
    uncategorized: 'Uncategorized',
    currency: '¥',
    addToCartSuccess: 'Added to cart',
    addToCartError: 'Add failed, please try again later',
    noMoreProducts: 'No more products',
    loadingMoreProducts: 'Loading more products...',
    expand: 'Expand',
    collapse: 'Collapse',
    expandMore: 'Show more ({count})',
    mobileHome: 'Home',
    mobileCategory: 'Category',
    mobileCart: 'Cart',
    mobileOrder: 'Orders',
    category: 'Category',
  },
  productDetail: {
    title: 'Product Detail',
    productCode: 'Product Code: ',
    price: 'Price',
    specs: 'Specifications',
    unit: 'Unit: ',
    quantity: 'Quantity',
    addToCart: 'Add to Cart',
    buyNow: 'Buy Now',
    productNote: 'Product Notes',
    notFound: 'Product Not Found',
    notFoundDesc: 'Sorry, the product you are looking for may have been removed or is temporarily unavailable',
    backToHome: 'Back to Home',
    copyCode: 'Copy Code',
    copyCodeSuccess: 'Product code copied',
    addCartSuccess: '{name} added to cart',
    addCartError: 'Add failed, please try again later',
    quantityMin: 'Quantity cannot be less than 1',
    loginRequired: 'Please login first',
    fetchError: 'Failed to get product details, please try again later',
    imageStatus: '{current}/{total}',
    new: 'New',
    hot: 'Hot',
  },
  profile: {
    title: 'Profile',
    admin: 'Administrator',
    user: 'User',
    account: 'Account Management',
    basicInfo: 'Basic Information',
    basicInfoDesc: 'View and manage your basic account information',
    security: 'Account Security',
    securityDesc: 'Manage your account security settings',
    userId: 'User ID',
    userAccount: 'User Account',
    userName: 'User Name',
    tenantId: 'Tenant ID',
    phone: 'Phone Number',
    email: 'Email',
    notSet: 'Not Set',
    set: 'Set',
    bind: 'Bind',
    change: 'Change',
    loginPassword: 'Login Password',
    phoneBinding: 'Phone Binding',
    changePassword: 'Change Password',
    resetPassword: 'Reset Password',
    phonePlaceholder: 'Please enter phone number',
    phoneRequired: 'Please enter phone number',
    phoneInvalid: 'Please enter a valid phone number',
    verificationCode: 'Verification Code',
    codePlaceholder: 'Please enter verification code',
    codeRequired: 'Please enter verification code',
    codeInvalid: 'Verification code must be 6 digits',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Please enter 6-20 characters new password',
    newPasswordRequired: 'Please enter new password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Please enter new password again',
    confirmPasswordRequired: 'Please confirm password',
    passwordLength: 'Password must be 4-20 characters',
    passwordMismatch: 'Passwords do not match',
    getCode: 'Get Code',
    resendAfter: 'Resend after {seconds}s',
    confirmReset: 'Confirm Reset',
    cancelResetConfirm: 'Are you sure you want to cancel password reset?',
    processing: 'Processing, please wait',
    resetSuccess: 'Password reset successful',
    resetFailed: 'Password reset failed, please try again later',
    languageDesc: 'Select your preferred interface language',
    passwordDesc: 'Changing your password regularly improves account security',
    phoneDesc: 'Binding phone number can be used for password reset and account security verification',
    bindPhoneInfo: 'Phone binding function under development...',
    bindEmailInfo: 'Email binding function under development...',
    codeSent: 'Verification code sent',
    // 新增地址管理相关翻译
    address: 'Address Management',
    addressDesc: 'View and manage your shipping addresses',
    defaultAddress: 'Default Address',
    usedCount: 'Used {count} times',
    lastUsed: 'Last Used',
    createdAt: 'Created At',
    createdBy: 'Created By',
    noAddress: 'No shipping addresses',
    fetchAddressFailed: 'Failed to fetch address list',
    resetPasswordHint: 'After resetting the password, it will be set to the default password 0000. Please keep it safe and change it promptly',
    reloginHint: 'Password has been reset. Please log in again with the new password 0000',
    modifyPassword: 'Change Password',
    modifyPasswordHint: 'You will need to log in again after changing the password.',
    oldPassword: 'Current Password',
    oldPasswordPlaceholder: 'Enter current password',
    newPasswordPlaceholder: 'Enter new password (min 4 characters)',
    confirmPasswordPlaceholder: 'Enter new password again',
    oldPasswordRequired: 'Please enter current password',
    passwordSame: 'New password cannot be the same as old password',
    passwordMismatch: 'Passwords do not match',
    confirmModify: 'Confirm Change',
    cancelModifyConfirm: 'Are you sure you want to cancel?',
    passwordModifySuccess: 'Password changed successfully! Please log in again.',
    passwordModifyFailed: 'Password change failed.',
    fetchCaptchaFailed: 'Failed to get captcha, please try again.',
    captchaRefresh: 'Click to refresh',
    contactAdminReset: 'Please contact administrator to reset password',
    addAddress: 'Add Address',
    editAddress: 'Edit Address',
    saveChanges: 'Save Changes',
    setDefault: 'Set as Default',
    defaultAddress: 'Default Address',
    noAddress: 'No Address',
    addAddressBtn: 'Add Address',
    contactRequired: 'Please enter contact name',
    phoneRequired: 'Please enter phone number',
    phoneInvalid: 'Invalid phone number format',
    areaRequired: 'Please select region',
    areaIncomplete: 'Region info incomplete, please reselect',
    addressRequired: 'Please enter detail address',
    setDefaultAddress: 'Set as default',
    saveAddressSuccess: 'Address added successfully',
    updateAddressSuccess: 'Address updated successfully',
    setDefaultAddressSuccess: 'Default address set successfully',
    saveAddressFailed: 'Failed to add address',
    updateAddressFailed: 'Failed to update address',
    setDefaultAddressFailed: 'Failed to set default address',
    fetchAddressFailed: 'Failed to fetch address list',
  },
  header: {
    welcome: 'Welcome to Ordering Mall',
    subtitle: 'Wholesale Mall',
    loginRegister: 'Login/Register',
    myAccount: 'My Account',
    myOrders: 'My Orders',
    myCart: 'My Cart'
  },
  login: {
    welcomeTitle: 'Welcome to Ordering System',
    welcomeDescription: 'Efficient and convenient ordering management platform, helping enterprises with digital procurement management, improving ordering efficiency and reducing operating costs.',
    feature1: 'Product Management',
    feature2: 'Order Processing',
    feature3: 'Inventory Query',
    feature4: 'Data Statistics',
    welcomeBack: 'Welcome back, please login to your account',
    username: 'Username',
    usernamePlaceholder: 'Please enter username',
    usernameRequired: 'Please enter username',
    usernameLength: 'Username must be 3-50 characters',
    password: 'Password',
    passwordPlaceholder: 'Please enter password',
    passwordRequired: 'Please enter password',
    passwordLength: 'Password must be 4-20 characters',
    captcha: 'Captcha',
    captchaPlaceholder: 'Please enter captcha',
    captchaRequired: 'Please enter captcha',
    captchaLength: 'Captcha must be 4 characters',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    forgotPasswordHint: 'Please contact administrator to reset password',
    noAccount: 'No account yet?',
    registerNow: 'Register now',
    loginSuccess: 'Login successful!',
    loginFailed: 'Login failed',
    loggingIn: 'Logging in...',
    testAccount: 'Test Account',
    defaultUsername: 'Admin',
    companyName: 'Ordering Mall',
    networkError: 'Network connection failed, please check your network settings',
    timeoutError: 'Request timeout, please try again later',
    credentialsError: 'Incorrect username or password',
    // 新增
    paramsError: 'Request parameter error',
    credentialsError: 'Incorrect username or password',
    disabledError: 'Account is disabled or no permission',
    endpointError: 'Login endpoint not found',
    serverError: 'Internal server error, please contact administrator',
    loginError: 'Login failed',
    loginRequestFailed: 'Login request failed',
    networkError: 'Network connection failed, please check your network settings',
    logoutFailed: 'Logout failed',
    logoutError: 'Logout request failed',
    tokenExpired: 'Token expired, local login state cleared',
    fetchUserFailed: 'Failed to get user info',
    fetchUserError: 'Failed to refresh user info',
    userInfoUpdated: 'User info updated',
  },
  register: {
    welcomeTitle: "Account Registration",
    welcomeDescription: "Become part of our platform and unlock powerful management capabilities",
    feature1: "Advanced Management Tools",
    feature2: "Seamless Multi-device Synchronization",
    feature3: "Real-time Performance Monitoring",
    feature4: "Expert Technical Support",
    title: "Create Account",
    subtitle: "Set up your new account credentials",
    title: 'Register New Account',
    subtitle: 'Create your wholesale mall account',
    mobile: 'Mobile Phone',
    mobilePlaceholder: 'Please enter mobile phone',
    realName: 'Real Name',
    realNamePlaceholder: 'Please enter real name',
    password: 'Password',
    passwordPlaceholder: 'Please enter password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Please enter password again',
    verifyCode: 'Verification Code',
    verifyCodePlaceholder: 'Please enter verification code',
    sendCode: 'Get Code',
    resendCode: 'Resend ({countdown}s)',
    agreement: 'I have read and agree to the User Agreement',
    registerButton: 'Register',
    hasAccount: 'Already have an account?',
    loginNow: 'Login Now',
    processing: 'Registering...',
    success: 'Registration successful! Please login',
    failure: 'Registration failed, please try again later',
    codeSent: 'Verification code sent',
    sendCodeFailed: 'Failed to send verification code',
    validation: {
      mobileRequired: 'Please enter mobile phone',
      mobileInvalid: 'Invalid mobile phone format',
      realNameRequired: 'Please enter real name',
      realNameLength: 'Name length is 2-50 characters',
      passwordRequired: 'Please enter password',
      passwordLength: 'Password length is 6-20 characters',
      confirmPasswordRequired: 'Please confirm password',
      passwordMismatch: 'Passwords do not match',
      verifyCodeRequired: 'Please enter verification code',
      verifyCodeInvalid: 'Verification code is 4 digits',
      agreementRequired: 'Please agree to the user agreement',
      sendTooFrequent: 'Sending too frequently, please try again later',
      dailyLimitReached: 'Daily sending limit reached, please try again tomorrow'
    }
  },

  checkout: {
    title: 'Checkout',
    back: 'Back',
    shippingInfo: 'Shipping Information',
    addAddress: 'Add Address',
    edit: 'Edit',
    setDefault: 'Set Default',
    default: 'Default',
    chooseOther: 'Choose Other Address',
    collapseAddress: 'Collapse',
    noAddress: 'No shipping addresses',
    addAddressBtn: 'Add Address',
    loadingAddress: 'Loading addresses...',
    productInfo: 'Product Information',
    totalItems: '{count} items',
    unit: 'Unit: ',
    orderSummary: 'Order Summary',
    totalPrice: 'Total Price',
    shippingFee: 'Shipping Fee',
    freeShipping: '¥0.00',
    totalPayable: 'Total Payable',
    orderRemark: 'Order Remark',
    remarkPlaceholder: 'Please enter order remark (optional, max 200 characters)',
    paymentMethod: 'Payment Method',
    noPayment: 'No Payment Required',
    noPaymentDesc: 'Suitable for internal settlement',
    onlinePayment: 'Online Payment',
    onlinePaymentDesc: 'Supports WeChat, Alipay, Bank Card',
    wechat: 'WeChat Pay',
    alipay: 'Alipay',
    bankCard: 'Bank Card',
    submitOrder: 'Submit Order ({count})',
    goPay: 'Pay Now',
    submitTipNoPayment: 'Click to submit order directly',
    submitTipPayment: 'Click to pay and redirect to payment page',
    selectAddressRequired: 'Please select a shipping address',
    contactInfoIncomplete: 'Shipping information incomplete, please complete contact and phone',
    cartEmpty: 'Please select items to purchase',
    confirmPayment: 'Confirm Payment',
    confirmPaymentDetail: 'Order total: ¥{amount}, confirm online payment?',
    confirmOrder: 'Confirm Order',
    confirmOrderDetail: 'Order total: ¥{amount}, confirm to submit order?',
    payNow: 'Pay Now',
    submitNow: 'Submit Order',
    cancel: 'Cancel',
    paymentSuccess: 'Payment and order placed successfully!',
    orderSuccess: 'Order placed successfully!',
    paymentFailed: 'Payment or order failed',
    orderFailed: 'Order submission failed',
    addressFormTitle: 'Add Address',
    editAddressTitle: 'Edit Address',
    contact: 'Contact',
    contactPlaceholder: 'Please enter contact name',
    phone: 'Phone',
    phonePlaceholder: 'Please enter phone number',
    area: 'Province/City/District',
    areaPlaceholder: 'Please select area',
    detailAddress: 'Detail Address',
    detailAddressPlaceholder: 'Please enter detailed address',
    setDefaultSwitch: 'Set as Default',
    save: 'Save',
    cancel: 'Cancel',
    saveSuccess: 'Address saved successfully',
    saveFailed: 'Failed to save address, please try again',
    fetchAddressFailed: 'Failed to get address list, please try again',
    setDefaultSuccess: 'Default address set successfully',
    setDefaultFailed: 'Failed to set default address, please try again',
    areaRequired: 'Please select a complete area',
    areaIncomplete: 'Area information is incomplete, please reselect',
    invalidPhone: 'Invalid phone number format',
    scanToPay: 'Scan to Pay',
    useWechatOrAlipayScan: 'Please scan with WeChat or Alipay',
    payLater: 'Pay Later',
    paymentCompleted: 'Payment Completed',
    qrGenerated: 'Payment QR code generated',
    submitOrderFailed: 'Failed to submit order',
    confirmPaySuccess: 'Confirm payment successful?',
    paymentConfirm: 'Payment Confirm',
    yes: 'Yes',
    no: 'No',
    qrExpireTip: 'Payment code expires in 15 minutes. Remaining time: ',
    qrExpired: 'Payment code has expired. Please go back and pay again.',
    qrExpiredMessage: 'Payment code has expired. Please pay again.',
    retryPay: 'Retry Payment',
    orderNotFound: 'Order not found',
    getPayUrlFailed: 'Failed to get payment URL',
    paymentSuccess: 'Payment successful',
    paymentFailed: 'Payment failed',
    success: 'Success',
    error: 'Error',
    ok: 'OK',
    orderWillRedirect: 'Order will redirect',
    redirectingIn: 'Redirecting in',
    orderDetailWillRefresh: 'Order detail will refresh',
    refreshingIn: 'Refreshing in'
  },
  cart: {
    title: 'Shopping Cart',
    back: 'Back',
    selectAll: 'Select All',
    selectedCount: '({count} selected)',
    deleteSelected: 'Delete Selected',
    clearCart: 'Clear Cart',
    code: 'Code: {code}',
    unit: 'Unit: {unit}',
    delete: 'Delete',
    emptyTitle: 'Your cart is empty',
    emptyDesc: 'Go and pick your favorite items',
    goHome: 'Go to Home',
    selectedProducts: 'Selected Items',
    total: 'Total: ',
    checkout: 'Checkout',
    checkoutCount: '({count})',
    confirmDeleteSelected: 'Are you sure you want to delete {count} items?',
    confirmDelete: 'Are you sure you want to delete this item?',
    confirmClear: 'Are you sure you want to clear the cart?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed, please try again',
    clearSuccess: 'Cart cleared',
    clearFailed: 'Clear failed, please try again',
    updateFailed: 'Failed to update quantity, please try again',
    selectWarning: 'Please select items to checkout',
    checkoutFailed: 'Checkout failed, please try again',
    quantityMin: 'Quantity cannot be less than 1',
    updateSelectFailed: 'Failed to update selection status, please try again',
    operationFailed: 'Operation failed, please try again',
    loginRequired: 'Please login first',
    addFailed: 'Failed to add to cart',
    updateFailed: 'Failed to update quantity',
    deleteFailed: 'Failed to delete item',
    batchDeleteFailed: 'Failed to batch delete',
    clearFailed: 'Failed to clear cart',
    updateSelectionFailed: 'Failed to update selection',
    itemNotFound: 'Cart item not found',
    cartItemNotFound: 'Cart item not found: {id}',
  },

  orderManage: {
    title: 'Order Management',
    back: 'Back',
    totalOrders: 'Total Orders',
    pendingConfirm: 'Pending Confirmation',
    shipped: 'Shipped',
    completed: 'Completed',
    cancelled: 'Cancelled',
    orderNo: 'Order No.',
    orderStatus: 'Order Status',
    allStatus: 'All Status',
    searchOrder: 'Search Orders',
    reset: 'Reset',
    refresh: 'Refresh',
    orderNoLabel: 'Order No.',
    createTime: 'Order Time',
    orderAmount: 'Amount',
    productQuantity: 'Quantity',
    status: 'Status',
    paymentStatus: 'Payment Status',
    shipmentTime: 'Shipment Time',
    voucherDate: 'Voucher Date',
    shippingInfo: 'Shipping Info',
    operation: 'Actions',
    detail: 'Details',
    statusPending: 'Pending Payment',
    statusConfirmed: 'Paid',
    statusShipping: 'Shipping',
    statusCompleted: 'Completed',
    statusCancelled: 'Cancelled',
    paymentUnpaid: 'Unpaid',
    paymentPaid: 'Paid',
    paymentCancelled: 'Cancelled',
    paymentRefunded: 'Refunded',
    paymentFailed: 'Failed',
    paymentProcessing: 'Processing',
    noOrders: 'No Orders Found',
    noOrdersDesc: 'No orders found under current filters.',
    viewAllOrders: 'View All Orders',
    totalCount: '{count} orders total',
    unitPiece: 'pcs',
    notShipped: 'Not Shipped',
    copySuccess: 'Copied to clipboard',
  },
  orderDetail: {
    title: 'Order Detail',
    back: 'Back',
    currentStatus: 'Current Status: ',
    orderCancelled: 'Order Cancelled',
    cancelReason: 'Reason: ',
    cancelTime: 'Cancelled At: ',
    stepPending: 'Pending',
    stepPendingDesc: 'Waiting for merchant confirmation',
    stepConfirmed: 'Confirmed',
    stepConfirmedDesc: 'Merchant confirmed',
    stepShipped: 'Shipped',
    stepShippedDesc: 'Items shipped',
    stepCompleted: 'Completed',
    stepCompletedDesc: 'Order completed',
    shippedTip: 'Items shipped, please confirm receipt.',
    cancelTip: 'Order not confirmed yet, you can cancel it.',
    cancelOrder: 'Cancel Order',
    confirmReceipt: 'Confirm Receipt',
    viewLogistics: 'View Logistics',
    confirmReceiptConfirm: 'Are you sure you have received the items? This will mark the order as completed.',
    cancelOrderTitle: 'Cancel Order',
    cancelOrderReasonPlaceholder: 'Please enter reason (optional)',
    confirmCancel: 'Confirm Cancel',
    cancelOrderWarning: 'Are you sure you want to cancel? This cannot be undone.',
    cancelOrderConfirmTitle: 'Confirm Cancellation',
    cancelOrderSuccess: 'Order cancelled successfully',
    orderInfo: 'Order Information',
    orderNoLabel: 'Order No.: ',
    createTime: 'Order Time: ',
    status: 'Status: ',
    totalQuantity: 'Total Items:',
    totalAmount: 'Total Amount: ',
    paymentStatusLabel: 'Payment Status: ',
    paymentTime: 'Payment Time: ',
    shipmentTime: 'Shipment Time: ',
    confirmTime: 'Confirm Time: ',
    voucherDate: 'Voucher Date: ',
    deliveryDate: 'Delivery Date: ',
    shippingInfo: 'Shipping Info',
    recipient: 'Recipient: ',
    phone: 'Phone: ',
    address: 'Address: ',
    remark: 'Order Remark',
    logisticsInfo: 'Logistics Info',
    logisticsCompany: 'Company: ',
    trackingNumber: 'Tracking No.: ',
    logisticsNetwork: 'Branch: ',
    trackingUrl: 'Tracking URL: ',
    clickToTrack: 'Click to Track',
    productInfo: 'Product Info',
    productName: 'Product Name',
    unit: 'Unit',
    quantity: 'Qty',
    unitPrice: 'Unit Price',
    taxRate: 'Tax Rate',
    subtotal: 'Subtotal',
    totalItems: '{count} items',
    totalQuantity: '{quantity} pcs total ',
    pointsAmount: 'Points Amount: ',
    discountAmount: 'Discount: ',
    orderTotal: 'Order Total: ',
    productCode: 'Code: ',
    productSpec: 'Spec: ',
    productBarcode: 'Barcode: ',
    orderNotFound: 'Order not found or deleted',
    backToOrderList: 'Back to Orders',
    copyOrderNo: 'Order No. copied to clipboard',
    copyTrackingNo: 'Tracking No. copied to clipboard',
    noLogistics: 'No logistics info available',
    payNow: "Pay Now",
    paySuccess: "Payment successful",
    payFailed: "Payment failed",
    orderIdMissing: "Order ID is missing",
    "payNow": "Pay Now",
    "paySuccess": "Payment successful",
    "payFailed": "Payment failed",
    "scanToPay": "Scan to Pay",
    "useWechatOrAlipayScan": "Use WeChat or Alipay to scan the QR code",
    "payLater": "Pay Later",
    "paymentCompleted": "Payment Completed",
    "confirmPaySuccess": "Confirm payment completed?",
    "paymentConfirm": "Payment Confirmation",
    "yes": "Yes",
    "no": "No"
  },
}

const i18n = createI18n({
  legacy: false,
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS
  }
})

export default i18n
